import { cn } from "@/lib/utils";

type BrandTheme = "light" | "dark";
type MarkVariant = "full" | "badge";

interface BrandMarkProps {
  className?: string;
  variant?: MarkVariant;
  alt?: string;
}

interface BrandLockupProps {
  className?: string;
  textClassName?: string;
  subtextClassName?: string;
  markClassName?: string;
  theme?: BrandTheme;
  showCountry?: boolean;
  markVariant?: MarkVariant;
}

const markSources: Record<MarkVariant, string> = {
  full: "/brand/proptrust-mark-full.png",
  badge: "/brand/proptrust-favicon.png",
};

export function BrandMark({
  className,
  variant = "full",
  alt = "PropTRUST logo",
}: BrandMarkProps) {
  return (
    <img
      src={markSources[variant]}
      alt={alt}
      className={cn("h-10 w-auto object-contain", className)}
      loading="eager"
      decoding="async"
    />
  );
}

export function BrandLockup({
  className,
  textClassName,
  subtextClassName,
  markClassName,
  theme = "light",
  showCountry = false,
  markVariant = "full",
}: BrandLockupProps) {
  const isDark = theme === "dark";

  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <BrandMark
        variant={markVariant}
        className={cn(markVariant === "badge" ? "h-10 w-10" : "h-9", markClassName)}
      />
      <div className="flex flex-col">
        <span
          className={cn(
            "font-bold tracking-tight",
            isDark ? "text-white" : "text-foreground",
            textClassName,
          )}
        >
          Prop
          <span className={cn(isDark ? "text-white" : "text-primary")}>TRUST</span>
        </span>
        {showCountry ? (
          <span
            className={cn(
              "text-[10px] -mt-0.5 tracking-[0.22em]",
              isDark ? "text-white/70" : "text-muted-foreground",
              subtextClassName,
            )}
          >
            NIGERIA
          </span>
        ) : null}
      </div>
    </div>
  );
}
